import { Alert, Button, Form, Input } from 'antd';
import React, { useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { Link, withRouter } from 'react-router-dom';
import bg from '../../../assets/img/bg.png';
import UserApi from '../../../functions/api/user/UserApi';
import MyUtil from '../../../functions/MyUtil';
import './Login.scss';

interface LoginFormData {
  username: string;
  password: string;
}

function Login(props: RouteComponentProps) {
  const [error, setError] = useState(false);
  async function handleSubmit(values: LoginFormData) {
    const credentials = {
      user_acc_name: values.username,
      user_acc_pass: values.password,
    };
    const response = await UserApi.login(credentials);

    const { url } = MyUtil.getQueryParam() as Record<string, string>;

    if (response?.data) {
      if (url && url?.includes('widget')) {
        props.history.replace(`${url}`);
        return;
      }

      props.history.replace('/');
      return;
    }

    setError(
      response?.message ?? 'Đã xảy ra lỗi, vui lòng thử lại sau ít phút !'
    );
  }

  return (
    <div className="container-fluid login-form">
      <div className="row wrapper">
        <div className="col-12 col-md-4 align-items-center d-flex">
          <Form
            layout="vertical"
            onFinish={handleSubmit}
            className="col-6 mx-auto"
          >
            <h2>Đăng nhập</h2>
            {error && <Alert type="error" message={error} className="my-3" />}
            <Form.Item name="username" required label="Email">
              <Input tabIndex={0} />
            </Form.Item>
            <Form.Item name="password" label="Mật khẩu" required>
              <Input type="password" />
            </Form.Item>
            <p>
              Chưa có tài khoản, vui lòng đăng ký{' '}
              <Link to="/register">Đăng ký</Link>
            </p>
            <Button htmlType="submit" block type="primary">
              Đăng nhập
            </Button>
          </Form>
        </div>

        <div
          className="d-none d-md-block col-md-8 right-image"
          style={{
            backgroundImage: `url(${bg})`,
          }}
        >
          <div className="des-login">
            Chungxe
            <div className="small mt-1">
              Nền tảng cho thuê xe và chia sẻ xe tự lái
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(Login);
